import { useNamedStore } from "@/lib/zustand/useNamedStore";
import { KeyOption } from "@/types/defs/keyOption";

type State = {
  initialPitchRequest: Promise<number[]>;
  suggestedKey: Promise<KeyOption>;
  sessionSlugRequest: Promise<string>;

  // this is the pitch array
  setInitialPitchRequest: (pitches: Promise<number[]>) => void;
  // this is the key
  setSuggestedKey: (suggestedKey: Promise<KeyOption>) => void;
  unsetSuggestedKey: () => void;
  // this is hubertization
  setSessionSlugRequest: (pitches: Promise<string>) => void;
};

const useHubertizationInput = (
  set: (
    partial:
      | State
      | Partial<State>
      | ((state: State) => State | Partial<State>),
    replace?: boolean
  ) => void
): State => ({
  initialPitchRequest: new Promise(() => {}),
  suggestedKey: new Promise(() => {}),
  sessionSlugRequest: new Promise(() => {}),

  setInitialPitchRequest: (initialPitchRequest: Promise<number[]>) =>
    set({ initialPitchRequest }),
  setSuggestedKey: (suggestedKey: Promise<KeyOption>) => set({ suggestedKey }),
  unsetSuggestedKey: () => set({ suggestedKey: new Promise(() => {}) }),
  setSessionSlugRequest: (sessionSlugRequest: Promise<string>) =>
    set({ sessionSlugRequest }),
});

export const useNamedHubertization = useNamedStore(() => useHubertizationInput);
